import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useLaNewItemPageLayoutExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.LaNewItemPageLayout,
        AmplitudeVariants.LaNewItemPageLayout.Treatment
    );
